import { render, staticRenderFns } from "./ActionRequiredUser.vue?vue&type=template&id=4e897bea&scoped=true"
import script from "./ActionRequiredUser.vue?vue&type=script&lang=ts"
export * from "./ActionRequiredUser.vue?vue&type=script&lang=ts"
import style0 from "./ActionRequiredUser.vue?vue&type=style&index=0&id=4e897bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e897bea",
  null
  
)

export default component.exports